import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';

const useStyles = makeStyles((theme: any) => ({
  root: {
    height: '100%',
    paddingLeft: ({ noPadding }: any) => (noPadding ? 0 : theme.spacing(1.5)),
    paddingRight: ({ noPadding }: any) => (noPadding ? 0 : theme.spacing(1.5)),
    position: 'relative',
  },
  card: {
    backgroundColor: ({ isGrey }: any) =>
      isGrey ? theme.palette.brand.greyMid4 : theme.palette.brand.white,
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    borderRadius: theme.spacing(1.5),
    border: '2px solid rgba(0, 0, 0, 0.08)',
    height: '100%',
    overflow: 'hidden',
  },
  headerContainer: {
    display: 'flex',
    flexWrap: 'wrap-reverse',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  header: {
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    fontSize: theme.spacing(2.75),
    lineHeight: `${theme.spacing(3)}px`,
  },
  topRight: {
    marginLeft: 'auto',
    paddingLeft: theme.spacing(1.5),
  },
}));

export default function Card(props) {
  const { title, topRight, isGrey, noPadding, className = '' } = props;
  const classes = useStyles({ isGrey, noPadding });
  return (
    <Container className={`${classes.root} ${className}`}>
      <div className={classes.card}>
        <div className={classes.headerContainer}>
          <h2 className={classes.header}>{title}</h2>
          <div className={classes.topRight}>{topRight}</div>
        </div>
        {props.children}
      </div>
    </Container>
  );
}
